export const SET_LIST = "ads/SET_LIST";